import "components/menuOptions/Menu.css";
import Accordion from "react-bootstrap/Accordion";
import AccountMenu from "components/menuOptions/AccountMenu";
import {
  faSliders,
  faUserCircle,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import FiltersMenu from "components/menuOptions/FiltersMenu";
import logo from "images/BlogFreeRecipeLogo.png";
import React, { useEffect, useState } from "react";

const MainMenu = (props) => {
  const [dynamicClasses, setDynamicClasses] = useState("");
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsAccountMenuOpen(false);
    setIsFilterMenuOpen(false);
  };

  const handleAccountClick = () => {
    setIsAccountMenuOpen(!isAccountMenuOpen);
    setIsMenuOpen(true);
    setIsFilterMenuOpen(false);
  };

  const handleFilterClick = () => {
    setIsFilterMenuOpen(!isFilterMenuOpen);
    setIsMenuOpen(true);
    setIsAccountMenuOpen(false);
  };

  const filterRecipes = (recipes) => {
    props.onFilter(recipes);
  };

  useEffect(() => {
    setIsMenuOpen(props.isAddOpen);
  }, [props.isAddOpen]);

  const updateClasses = () => {
    setTimeout(
      () => {
        let classes = isMenuOpen ? "is-open" : "";
        setDynamicClasses(classes);
      },
      isMenuOpen ? 0 : 150,
    );
  };

  useEffect(() => {
    updateClasses();
  }, [isMenuOpen]);

  return (
    <header className={`App-header ${dynamicClasses}`}>
      {/* Always visible header */}
      <div className="Row Space-B">
        <div className="Row JC-Left">
          <Link to="/" className="Logo-Home-Btn">
            <img src={logo} className="App-logo" id="Menu-Logo" alt="logo" />
          </Link>
          <h1 className="Menu-Header">Blog Free Recipe</h1>
        </div>
        <div className="Row">
          {!props.isAddOpen && (
            <>
              {isMenuOpen ? (
                <button className="Filter" onClick={closeMenu}>
                  <FontAwesomeIcon
                    className="fa-thin fa-2xl"
                    icon={faWindowClose}
                  />
                </button>
              ) : (
                <>
                  <button className="Filter" onClick={handleFilterClick}>
                    <FontAwesomeIcon
                      className="fa-thin fa-2xl"
                      icon={faSliders}
                    />
                  </button>
                  <button className="Account" onClick={handleAccountClick}>
                    <FontAwesomeIcon
                      className="fa-thin fa-2xl white"
                      icon={faUserCircle}
                    />
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Expandable menu section */}
      <Accordion
        activeKey={isMenuOpen ? "menu" : null}
        className={props.isAddOpen ? "add-menu" : ""}
      >
        <Accordion.Item eventKey="menu">
          <Accordion.Body>
            {isAccountMenuOpen && <AccountMenu oncloseMenu={closeMenu} />}
            {isFilterMenuOpen && (
              <FiltersMenu
                recipes={props.recipes}
                onFilterRecipes={filterRecipes}
                onHandleActions={closeMenu}
              />
            )}
            {props.isAddOpen && <div className="full-height" />}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </header>
  );
};

export default MainMenu;
